"use strict";
/**
 * @module Services.TopicUpdate
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Codec = require("./../../io/codec");
var serialiser_1 = require("./../../serialisers/serialiser");
var error_report_list_serialiser_1 = require("./../../services/error-report-list-serialiser");
var create_topic_view_result_1 = require("./create-topic-view-result");
var read_topic_view_1 = require("./read-topic-view");
/**
 * Serialiser for {@link CreateTopicViewResult}
 */
var CreateTopicViewResultSerialiserClass = /** @class */ (function (_super) {
    __extends(CreateTopicViewResultSerialiserClass, _super);
    function CreateTopicViewResultSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Read a {@link ListTopicViewsResult} from the stream
     *
     * @param bis  the input stream
     * @return     the {@link ListTopicViewsResult} that was read
     */
    CreateTopicViewResultSerialiserClass.prototype.read = function (bis) {
        if (bis.peek() === 0) {
            // consume the zero from the input stream
            Codec.readByte(bis);
            var topicView = read_topic_view_1.readTopicView(bis);
            return new create_topic_view_result_1.CreateTopicViewResult(topicView);
        }
        else {
            var errors = error_report_list_serialiser_1.ErrorReportListSerialiser.read(bis);
            return new create_topic_view_result_1.CreateTopicViewResult(undefined, errors);
        }
    };
    return CreateTopicViewResultSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.CreateTopicViewResultSerialiserClass = CreateTopicViewResultSerialiserClass;
/**
 * The {@link CreateTopicViewResultSerialiser} singleton
 */ // tslint:disable-next-line:variable-name
exports.CreateTopicViewResultSerialiser = new CreateTopicViewResultSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/topic-views/create-topic-view-result-serialiser.js
// module id = 1424
// module chunks = 1